import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  $('.two-halves-slider').each((i, el) => {
    const swiperConfig = {
      loop: true,
    };

    const textes = el.querySelector('.two-halves-slider__textes');
    const images = el.querySelector('.two-halves-slider__images');

    if (!textes || !images) return;

    const textesSwiper = new Swiper(textes, { ...swiperConfig, spaceBetween: 30 });
    const imagesSwiper = new Swiper(images, swiperConfig);

    textesSwiper.controller.control = imagesSwiper;
    imagesSwiper.controller.control = textesSwiper;
  });
});



// WEBPACK FOOTER //
// ./scripts/blocks/two-halves-slider.js